import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Videos'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Videos'

export const mediaPlatformVideosRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.VIDEOS,
  loader: () => ({
    crumb: t('entity:publishing.video', { count: 2 }),
  }),
})

export const mediaPlatformVideosLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformVideosRoute,
  id: 'mediaPlatformVideosLayout',
  component: Structure,
})

type MediaPlatformVideosOverviewSearch = {
  query?: string
}

export const mediaPlatformVideosOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformVideosLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformVideosOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
